/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function NotEditable({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" {...props}><path fill="currentColor" d="M38.8 69.1c-10.4-8.2-25.5-6.3-33.7 4.1s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 360l146.8-146.7c21.9-21.9 24.6-55.6 8.2-80.5-2.3-3.5-5.1-6.9-8.2-10l-39.4-39.5c-25-25-65.5-25-90.5 0L264.3 245.8zm263.5 206.5L385 193l62 62-75.1 75.1zm.9 123.2-41.7 41.7-49.6-12.4-12.4-49.6 34.4-34.4-38-29.9-73.2 73.2c-2.5 2.5-4.9 5.2-7.1 8l-.8.5.2.3c-6.5 8.5-11.4 18.2-14.5 28.6L77.4 503 65 545.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l42.2-12.4 78.1-23c10.4-3 20.1-8 28.6-14.5l.3.2.5-.8c1.4-1.1 2.7-2.2 4-3.3 1.4-1.2 2.7-2.5 4-3.8l88.6-88.6-38-29.9zM161 422.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9-54.8 16.1 16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L161 423z" /></svg>;
}
;